import React from 'react'
import { useSelector } from 'react-redux'
import { Navigate } from 'react-router-dom'

function PrivateRoute({ component: Component, authenticated, ...rest }) {

    const { token } = useSelector((state) => state.auth)



    return token ? <Component {...rest} /> : <Navigate to="/login" replace />
}

export default PrivateRoute